import { Fragment } from 'react';

import { IonCardTitle, IonItem, IonLabel, IonThumbnail } from '@ionic/react';

import styles from './SignedInHeader.module.scss';

import { Service } from '../../services/service';
import { Image } from '../Image/Image';

export interface SignedInHeaderProps {
  login: string;
  name: string;
  photoUrl: string;
  service: Service;
  token?: string;
}

export const SignedInHeader = ({
  photoUrl,
  name,
  login,
  token,
  service
}: SignedInHeaderProps) => (
  <Fragment>
    <IonCardTitle className={styles.title}>
      Successfully signed in as
    </IonCardTitle>
    <IonItem lines="none">
      <IonThumbnail slot="start" className={styles.avatar}>
        <Image service={service} url={photoUrl} token={token} />
      </IonThumbnail>
      <IonLabel>
        <h2>{name}</h2>
        <p>{login}</p>
      </IonLabel>
    </IonItem>
  </Fragment>
);
